import React, { useRef } from 'react';
import c from 'classnames';

// Subcomponents.
import TopMenu from './TopMenu';

interface Subcomponents {
  TopMenu: typeof TopMenu;
}

export interface MegaMenuProps {
  className?: string;
  children: React.ReactNode;
}

const MegaMenu: React.FC<MegaMenuProps> & Subcomponents = (props) => {
  const { className, children } = props;

  const openOverlayDelay = useRef<NodeJS.Timeout | null>(null);

  const classNames = c('MegaMenu', className);

  return (
    <div
      className={classNames}
      onMouseLeave={() => {
        if (openOverlayDelay.current) {
          clearTimeout(openOverlayDelay.current);
        }
      }}
    >
      {children}
    </div>
  );
};

MegaMenu.TopMenu = TopMenu;

export default MegaMenu;
